import { useMemo } from 'react'

export const ROUTE_TO_DASHBOARD_NAME = {
  'insights-portal/performance/overview': 'performance',
  'insights-portal/performance/out-of-stock': 'out_of_stock',
  'insights-portal/performance/basket': 'basket',
  'insights-portal/performance/search': 'search',
  'insights-portal/executive-summary': 'executive',
  'insights-portal/custom-report': 'data_explorer',
  'insights-portal/ads-dashboard': 'ads',
  '/dashboard': 'homepage',
}

interface InsightsPortalQueryTag {
  name: string
  value: string
}

export const useInsightsPortalQueryTags = (customTags?: Record<string, string>) => {
  const queryTags: InsightsPortalQueryTag[] = useMemo(() => {
    const defaultTags = [
      {
        name: 'dashboard',
        value:
          ROUTE_TO_DASHBOARD_NAME[
            Object.keys(ROUTE_TO_DASHBOARD_NAME).find(d => window.location.pathname.includes(d))
          ] ?? window.location.pathname.split('/').pop(),
      },
    ]

    if (customTags) {
      return [
        ...defaultTags,
        // convert customTags from { foo: bar } to { name: 'foo', value: 'bar' }
        ...Object.entries(customTags).map(([name, value]) => ({ name, value })),
      ]
    }

    return defaultTags
  }, [customTags])

  return queryTags
}
